var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C781F80A-E0B6-4A36-A140-11E5C6DD0913") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.000360902256 0.383819549 79.616 0.383819549 79.616 80 0.000360902256 80"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hospitalization-desktop",
    transform: "translate(-223.000000, -1694.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(223.000000, 1694.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.616,40.1919398 C79.616,62.1775038 61.7928421,80.0000602 39.8072782,80.0000602 C17.8229173,80.0000602 0.000360902256,62.1775038 0.000360902256,40.1919398 C0.000360902256,18.2063759 17.8229173,0.383819549 39.8072782,0.383819549 C61.7928421,0.383819549 79.616,18.2063759 79.616,40.1919398",
    id: "Fill-1",
    fill: "#3A913F",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36.5003059,20.9256842 C32.8746584,20.9256842 29.9256842,23.8746584 29.9256842,27.5003059 C29.9256842,31.1253416 32.8746584,34.0743158 36.5003059,34.0743158 C40.1253416,34.0743158 43.0743158,31.1253416 43.0743158,27.5003059 C43.0743158,23.8746584 40.1253416,20.9256842 36.5003059,20.9256842 M36.5003059,35 C32.3644002,35 29,31.6355998 29,27.5003059 C29,23.3644002 32.3644002,20 36.5003059,20 C40.6355998,20 44,23.3644002 44,27.5003059 C44,31.6355998 40.6355998,35 36.5003059,35",
    id: "Fill-4",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5463794,61 C47.2962298,61 47.0933573,60.7964677 47.0933573,60.5455046 L47.0933573,40.8358933 C47.0933573,40.0529844 46.7899461,39.3187072 46.2387792,38.7657477 C45.6888091,38.2127883 44.9563136,37.9089908 44.176541,37.9089908 L27.8228606,37.9095912 C26.214243,37.9095912 24.9060443,39.2226447 24.9060443,40.8364937 L24.9060443,50.1137239 C24.9060443,51.7287737 26.214243,53.0406264 27.8228606,53.0406264 L33.358468,53.0406264 C33.6080192,53.0406264 33.8108917,53.2441587 33.8108917,53.4945214 C33.8108917,53.7454846 33.6080192,53.9496173 33.358468,53.9496173 L27.8228606,53.9496173 C25.7157391,53.9496173 24,52.2294992 24,50.1137239 L24,40.8364937 C24,38.7219192 25.7157391,37.0006004 27.8228606,37.0006004 L44.176541,37 C45.1974865,37 46.1579892,37.3986591 46.8803112,38.1233302 C47.6020347,38.8480012 48,39.8110272 48,40.8358933 L48,60.5455046 C48,60.7964677 47.7971275,61 47.5463794,61",
    id: "Fill-6",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5003305,47 C29.2240582,47 29,46.7948687 29,46.5419339 L29,42.457461 C29,42.2051313 29.2240582,42 29.5003305,42 C29.7759418,42 30,42.2051313 30,42.457461 L30,46.5419339 C30,46.7948687 29.7759418,47 29.5003305,47",
    id: "Fill-8",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2305978,53.0883072 L36.4507076,53.0883072 C38.4026563,53.0883072 40.0062351,52.3976126 41.2195439,51.032482 C44.5063119,47.3339237 44.1441748,39.7453154 44.0017143,37.9116928 L42.7955884,37.9116928 L34.2305978,53.0883072 Z M36.4507076,54 L33.4530507,54 C33.2920343,54 33.1429895,53.9126846 33.0615835,53.7735822 C32.9801775,53.6326733 32.9795789,53.4598491 33.0591892,53.3195423 L42.1377559,37.2312352 C42.2185634,37.0885197 42.3688054,37 42.5316174,37 L44.4165259,37 C44.6463781,37 44.840316,37.1746307 44.8660547,37.4058659 C44.876829,37.5034182 45.1330185,39.8500939 44.9073563,42.7772661 C44.6008865,46.7528249 43.5875013,49.7347951 41.8959322,51.6388722 C40.5030512,53.2045269 38.6714158,54 36.4507076,54 L36.4507076,54 Z",
    id: "Fill-10",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5363143,47 L24.4636857,47 C24.2076479,47 24,46.7759418 24,46.5003305 C24,46.2240582 24.2076479,46 24.4636857,46 L37.5363143,46 C37.7923521,46 38,46.2240582 38,46.5003305 C38,46.7759418 37.7923521,47 37.5363143,47",
    id: "Fill-12",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4349516,53 C25.3653232,53 25.294544,52.9830947 25.2289437,52.9450577 C25.0166059,52.825513 24.9383459,52.5483866 25.0522832,52.3274099 L28.1815323,46.2402887 C28.2960451,46.0181046 28.5601726,45.9353893 28.7713595,46.0543303 C28.9831219,46.173875 29.0619573,46.4510014 28.9474445,46.6731856 L25.8181954,52.7609105 C25.73936,52.9130584 25.5897453,53 25.4349516,53",
    id: "Fill-14",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4829623,54 C29.4043185,54 29.3243959,53.9820758 29.2502278,53.9419007 C29.0162146,53.817049 28.931177,53.5327334 29.0603318,53.3071351 L33.0929041,46.2418907 C33.2220589,46.0156743 33.5161739,45.93347 33.7501871,46.0583217 C33.983561,46.1837914 34.0685986,46.4668709 33.9400831,46.6943235 L29.9068715,53.7583317 C29.818637,53.9128511 29.6536768,54 29.4829623,54",
    id: "Fill-16",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5,61 C43.2232497,61 43,60.8004438 43,60.5543833 L43,48.4450281 C43,48.1995562 43.2232497,48 43.5,48 C43.7760898,48 44,48.1995562 44,48.4450281 L44,60.5543833 C44,60.8004438 43.7760898,61 43.5,61",
    id: "Fill-18",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5003305,61 C29.2240582,61 29,60.8073238 29,60.5697467 L29,54.4291166 C29,54.1915395 29.2240582,54 29.5003305,54 C29.7759418,54 30,54.1915395 30,54.4291166 L30,60.5697467 C30,60.8073238 29.7759418,61 29.5003305,61",
    id: "Fill-20",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62,28.9914275 L54.0236156,28.9914275 L54.0236156,21 L48.672842,21 L48.672842,28.9914275 L44.4763844,28.9914275 C44.0720684,30.9566215 43.0002036,32.7682846 41,34.0085725 L48.672842,34.0085725 L48.672842,42 L54.0236156,42 L54.0236156,34.0085725 L62,34.0085725 L62,28.9914275 Z",
    id: "Fill-22",
    fill: "#FFFFFF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWounded);
export default __webpack_public_path__ + "static/media/wounded.4e06c014ef5c97348d2b09ce48a12174.svg";
export { ForwardRef as ReactComponent };